<template>
	<div class="job-matches__items">
		<block-spinner :active="isLoading" size="4" color="text-blue" key="spinner" class="mt-2"></block-spinner>
		<div class="job-matches__container" v-if="!isLoading">
			<template v-if="count == 0">
				<p class="job-matches__title">You don't have any job matches.</p>
				<p class="job-matches__tip">TIP: Try changing your preferences OR <b>search jobs</b>. You can now set up job alerts with your own unique filter combinations.</p>
			</template>
			<template v-else>
				<template v-if="all_seen">
					<p class="job-matches__title">You've reviewed all your job matches.</p>
					<div class="job-matches__summary">
						<div class="job-matches__counter grey">{{ matches}} roles</div>
						<a :href="calculate_link(jobs[0])" class="job-matches__btn">Take another look</a>
					</div>
				</template>
				<template v-else>
					<p class="job-matches__title">New matches to review.</p>
					<div class="job-matches__summary">
						<div class="job-matches__counter blue">{{ matches}} roles</div>
						<a :href="calculate_link(jobs[0])" class="job-matches__btn">Review</a>
					</div>
				</template>
			</template>
		</div>
	</div>

</template>

<script>
	import RecommendedJobs from '@/mixins/RecommendedJobs';

	export default {
		name: 'JobsRecommendedMatches',

    mixins: [RecommendedJobs],

		data() {
			return {
				recommended_jobs: false,
				manager: true
			}
		},
		created() {
			this.emitter.on('refresh:recommended:jobs', this.refreshState);
      this.refreshState();
		},
		methods: {
			refreshState() {
				this.recommended_jobs = this.getRecommended();
				console.log("this.recommended_jobs",this.recommended_jobs);
			},
		},
		computed: {
			jobs() {
				return this.recommended_jobs.jobs;
			},
			matches() {
				return this.jobs.length
			},
			isLoading() {
				return this.recommended_jobs == false || this.recommended_jobs == null || this.loading;
			}
		}
	}
</script>
